function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { Suspense, useState } from 'react';
import dayjs from 'dayjs';
import { Button } from 'antd';
import MonthFilter from '../../components/filter/month-filter';
import ModalUserActivity from '../../components/modal/modal-user-activity';
import UserActivityTable from './section-activity-table';
import UserActivityTopCards from './section-user-activity-top';
import { columnUserVisitPage } from '../../../utils/common-chart';
import SkeletonUserActivityTopCards from '../../sekeletons/skeleton-user-login';
export default function SectionUserActivityPanel() {
    const _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isModalOpen = _useState2[0], setIsModalOpen = _useState2[1];
    const _useState3 = useState({
        page: 1,
        start_date: dayjs().startOf('month').format('YYYY-MM-DD'),
        end_date: dayjs().endOf('month').format('YYYY-MM-DD')
    }), _useState4 = _slicedToArray(_useState3, 2), params = _useState4[0], setParams = _useState4[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-50 p-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-2xl font-semibold"
    }, "\u52D5\u4F5C"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => setIsModalOpen(true)
    }, "\u8A73\u7D30\u3092\u898B\u308B"))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-6"
    }, /*#__PURE__*/ React.createElement(MonthFilter, {
        onChange: (start_date, end_date) => setParams(prev => _objectSpread(_objectSpread({}, prev), {}, {
            start_date,
            end_date
        }))
    })), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 gap-6"
    }, /*#__PURE__*/ React.createElement(UserActivityTable, {
        params: params
    }), /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonUserActivityTopCards, null)
    }, /*#__PURE__*/ React.createElement(UserActivityTopCards, {
        params: {
            start_date: params.start_date,
            end_date: params.end_date
        }
    }))), isModalOpen && /*#__PURE__*/ React.createElement(ModalUserActivity, {
        columns: columnUserVisitPage,
        filterParams: params,
        onCancel: () => setIsModalOpen(false)
    }));
}
